<template>
    <div class="col-sm-12">
        <template v-if="zum.length > 0">
            <div v-for="z in zum" class="card-text" :data-testid="'visit-zum-' + z.id">
                <div class="d-flex justify-content-between border border-light">
                    <!--<div class="p-0 text-secondary" v-if="m.internal">
                        {{ m.operation.code }} <i title="interní výkon" class="fa fa-hand-spock-o text-danger" aria-hidden="true"></i> {{ m.operation.name }}
                    </div>-->
                    <div class="p-0">
                        {{ z.material.label }} <span> množství: {{ z.amount }} </span>
                    </div>
                    <div class="p-0">
                        <button v-if="!zumPending" @click="zumPending ? null : removeZum(z.id)" class="btn btn-sm btn-outline-danger" :data-testid="'visit-zum-delete-' + z.id"><i class="fa fa-trash-o" aria-hidden="true"></i></button>
                        <button class="btn btn-sm btn-outline-danger disabled" v-else=""><i class="fa fa-trash-o" aria-hidden="true"></i></button>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
  import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        waitForResponse: false,
        // zum: [],
        zumReload: '',
        zumPending: false,
        // ZUM DELETE
        deletZumPending: false,
        deletZumDone: false,
        deletZumError: false
      }
    },
    props: ['doUpdate', 'diagnosisId', 'zum'],
    mixins: [apiMixin],
    methods: {
      /* getActions () {
        this.zumPending = true
        this.$http.get('/diagnosis/' + this.diagnosisId + '/action').then(response => {
          this.zum = response.data
          this.zumPending = false
          this.zumListUpdated()
        }, response => {
          this.zum = []
          this.zumPending = false
        })
      }, */
      updateDiagnosis () {
        this.$emit('update')
      },
      removeZum (id) {
        this.deleteZum(id)
      }
    },
    watch: {
      deletZumDone (val) {
        if (val === true) {
          this.deletZumPending = false
          this.deletZumDone = false
          this.deletZumError = false
          this.$emit('update')
        }
      }
    },
    beforeMount () {
      //
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Visit/components/ListZum.vue?cc693568